import gql from 'graphql-tag';

const GET_BANNER_COLLAGE = gql`
  query GetBannerCollage($id: String!) {
    bannerCollage(id: $id) {
      title
      large {
        image {
          alt
          url
        }
        link {
          title
          url
          urlType
        }
        trackingEvent
      }
      small {
        image {
          alt
          url
        }
        link {
          title
          url
          urlType
        }
        trackingEvent
      }
    }
  }
`;

export default GET_BANNER_COLLAGE;
